export const GGAC = () => {
  return (
    <div>
      <div id="ggac-base"></div>
    </div>
  );
};
